/* LASTU · KONFIGURAATTORIN VAIHEIDEN TIIVISTYS (vain mobiili) – v2 9.10.2026 ilta
   SÄÄNTÖ (yksi, ennalta arvattava): VALMIS osio pienenee yhdelle riville ("✓ MAGSAFE  KRIP + KARB  Muuta"),
   kun asiakas tekee valinnan JOSSAIN MUUSSA osiossa. Ei ajastimia, ei tyhjän kohdan klikkausta, ei vieritystä.
   - Puhelin (merkki + malli) tiivistyy heti kun malli on valittu (ainoa poikkeus: aina valmis ja harvoin muutettava).
   - Osiot: puhelin, materiaali ja jokainen konfiguraattorin rivi (data-row: kaiverrus, kartta, kuva, logo, velcro,
     teksti, MagSafe + KRIP/KARB, LEKA) – sama logiikka puu-, camo- ja muissa tuotteissa.
   - Keskeneräinen ei tiivisty koskaan (LEKA ilman määrää, tyhjä teksti, kuva puuttuu…). Esivalittu kaiverrus ei ole
     asiakkaan valinta → vaihtoehdot pysyvät näkyvissä kunnes asiakas valitsee itse.
   - Koko rivi tiivistyy (myös "Lisää kaiverrus valikoimastamme" -valinta karusellin mukana).
   - Sivu ei hyppää: jos tiivistyvä osio on klikatun kohdan yläpuolella, vieritys korjataan (klikattu kohta pysyy paikallaan).
   - "Muuta" avaa osion; virheilmoitus avaa kaikki. Ohjelmalliset valinnat (luonnos/muokkaus) tiivistävät mutta eivät vieritä.
   Konfiguraattorin tila luetaan window.__lastuK:n kautta (assets/lastu-konfiguraattori.js).
   v1 (9.10. päivä): vain puhelin/materiaali/kaiverruskortit, "moved"-liput. Alapalkki + esikatselukaista hylätty demossa 9.10. */
(function () {
  function start() {
    var K = window.__lastuK; if (!K || !K.currentModel || start.done) return; start.done = true;
    var html = document.documentElement, root = document.getElementById('lastu-k'), st = K.state, D = K.data;
    if (!root) return;
    var en = /^en\b/.test(html.lang || '') || /\/en(\/|$)/.test(location.pathname);
    var T = en
      ? { phone: 'Phone', mat: 'Material', engraving: 'Engraving', kartta: 'Map', upload: 'Image', print: 'Logo', velcro: 'Velcro', text: 'Text', magsafe: 'MagSafe', leka: 'LEKA', change: 'Change', on: 'Added', img1: 'image', imgN: 'images', pcs: 'pcs' }
      : { phone: 'Puhelin', mat: 'Materiaali', engraving: 'Kaiverrus', kartta: 'Kartta', upload: 'Kuva', print: 'Logo', velcro: 'Velcro', text: 'Teksti', magsafe: 'MagSafe', leka: 'LEKA', change: 'Muuta', on: 'Lisätty', img1: 'kuva', imgN: 'kuvaa', pcs: 'kpl' };
    if (root.getAttribute('data-mode') === 'camo') T.engraving = en ? 'Badge' : 'Merkki';   /* camossa valikoima = merkit */
    var mob = function () { return K.isMobile ? K.isMobile() : innerWidth < 768; };
    var $ = function (s) { return root.querySelector(s); };

    /* Osiot: avain → elementit (ensimmäisen eteen tulee yhteenvetorivi) */
    /* 10.10.2026 (käyttäjä): tiivistys ei toiminut asiakkaille → VAIN puhelinmerkki + -malli tiivistyy yhdeksi riviksi.
       Materiaali ja muut rivit (kaiverrus, kuva, teksti, MagSafe, LEKA…) pysyvät aina auki. Palautus: lisää mat-ryhmä ja
       data-row-silmukka takaisin (varmuuskopio ~/lastu-data/tiivistys-1010-ennen/lastu-vaiheet.js). */
    var groups = { phone: [$('#lastu-k-step-brand'), $('#lastu-k-step-model')] };
    var closed = {}, picked = false;   /* closed = asiakas siirtyi muualle osion valmistuttua; picked = oma kaiverrusvalinta */

    function sectionOf(el) {
      if (!el || !el.closest) return null;
      if (el.closest('#lastu-k-step-brand, #lastu-k-step-model')) return 'phone';
      if (el.closest('#lastu-k-step-material')) return 'mat';
      var r = el.closest('.lastu-k__row[data-row]'); if (r && root.contains(r)) return r.getAttribute('data-row');
      if (el.closest('fieldset[id^="lastu-k-step-"]')) return 'other';   /* kartta/sanat/kuvat-tuotteen oma editori */
      return null;
    }
    function short(s, n) { s = String(s || '').split('\n')[0].trim(); return s.length > n ? s.slice(0, n - 1) + '…' : s; }
    /* Valmis? → yhteenvedon arvo (tyhjä merkkijono kelpaa), keskeneräinen → null */
    function value(key) {
      var m = K.currentModel(), mat = K.currentMaterial();
      switch (key) {
        case 'phone': return m ? m.name : null;
        case 'mat': return mat ? mat.name : null;
        case 'engraving': { var e = D.engravings && D.engravings[st.engraving]; return st.persona === 'engraving' && e && picked ? e.name : null; }
        case 'kartta': return st.persona === 'kartta' && st.kartta && st.kartta.center ? short(st.kartta.place || st.kartta.q, 26) || T.on : null;
        case 'upload': { var n = (st.uploads || []).filter(function (u) { return u.maskCanvas; }).length; return st.persona === 'upload' && n ? n + ' ' + (n > 1 ? T.imgN : T.img1) : null; }
        case 'print': return st.persona === 'print' && st.print && (st.print.img || st.print.file) ? short(st.print.name, 22) || T.on : null;
        case 'velcro': return st.persona === 'velcro' ? T.on : null;
        case 'text': { var t = st.text.on ? st.text.items.filter(function (x) { return String(x.value || '').trim(); }) : []; return t.length ? '”' + short(t[0].value, 22) + '”' + (t.length > 1 ? ' +' + (t.length - 1) : '') : null; }
        case 'magsafe': { if (!st.magsafe) return null; var a = Object.keys(st.addons || {}).filter(function (i) { return st.addons[i] && D.addons[+i]; }).map(function (i) { return String(D.addons[+i].name).split(/\s/)[0]; }); return a.length ? a.join(' + ') : T.on; }
        case 'leka': return st.leka && st.lekaCount ? st.lekaCount + ' ' + T.pcs : null;
      }
      return null;
    }
    function sumRow(key, before) {
      var r = root.querySelector('.lux-sum[data-k="' + key + '"]');
      if (!r) {
        r = document.createElement('div'); r.className = 'lux-sum'; r.setAttribute('data-k', key); r.hidden = true;
        r.innerHTML = '<span class="lux-sum__ok" aria-hidden="true">✓</span><span class="lux-sum__k"></span><b class="lux-sum__v"></b><button type="button" class="lux-sum__c"></button>';
        r.querySelector('.lux-sum__k').textContent = T[key] || key; r.querySelector('.lux-sum__c').textContent = T.change;
        r.querySelector('.lux-sum__c').setAttribute('aria-label', T.change + ': ' + (T[key] || key));   /* ruudunlukija: "Muuta: Puhelin" */
        /* 10.10.2026: koko rivi napautettava (Muuta-linkki oli vain 28 px korkea) */
        r.addEventListener('click', function () {
          /* avautuva osio alkaa täsmälleen yhteenvetorivin kohdalta → ei hyppyä */
          var y = r.getBoundingClientRect().top; closed[key] = false; apply();
          var f = groups[key][0]; if (f) { var dy = f.getBoundingClientRect().top - y; if (Math.abs(dy) > 1) window.scrollBy(0, dy); }
        });
        before.parentNode.insertBefore(r, before);
      }
      return r;
    }
    /* Palauttaa { r, h } kun osio tiivistyy JUURI NYT (animaatiota varten): r = yhteenvetorivi, h = osion korkeus ennen. */
    function setGroup(key) {
      var g = (groups[key] || []).filter(Boolean); if (!g.length) return null;
      if (g[0].hidden && !g[0].classList.contains('lux-done')) return null;   /* osio ei käytössä tässä tuotteessa / tilassa */
      var v = value(key), collapse = !!(v !== null && closed[key]);
      if (v === null) closed[key] = false;   /* keskeneräiseksi muuttunut aukeaa ja pysyy auki */
      var r = sumRow(key, g[0]), was = !r.hidden, h = 0, bottom = 0;
      if (collapse && !was) { var a = g[0].getBoundingClientRect(), b = g[g.length - 1].getBoundingClientRect(); h = Math.max(0, b.bottom - a.top); bottom = b.bottom; }
      g.forEach(function (f) { f.classList.toggle('lux-done', collapse); });
      r.hidden = !collapse; r.querySelector('.lux-sum__v').textContent = v || '';
      return collapse && !was ? { r: r, h: h, bottom: bottom } : null;
    }
    function apply() {
      if (!mob()) {
        root.querySelectorAll('.lux-done').forEach(function (f) { f.classList.remove('lux-done'); });
        root.querySelectorAll('.lux-sum').forEach(function (r) { r.hidden = true; });
        return [];
      }
      var fresh = [];
      Object.keys(groups).forEach(function (k) { var x = setGroup(k); if (x) fresh.push(x); });
      return fresh;
    }
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function shown(el) { return !!(el && document.contains(el) && el.getClientRects().length); }
    /* 10.10.2026: NÄKYMÄ EI SAA HYPÄTÄ.
       - Klikattu kohta pysyy samassa kohtaa ruutua (ankkuri), kun muualla oleva osio tiivistyy.
       - Jos klikattu osio itse tiivistyy (puhelin), sen yhteenvetorivi asettuu siihen kohtaan, missä klikattu valinta oli.
       - Tiivistyminen on 0,32 s taittuminen (yhteenveto kutistuu osion korkeudesta riviksi) ja rivi välähtää vihreänä
         → asiakas näkee mihin valinta meni. Ankkuria pidetään paikallaan joka ruudussa animaation ajan.
       BUGI 9.10.: ankkuri oli mallivalikon fieldset, joka itse piiloutui → mitta 0 → sivu vieritti ylös tuotekuvaukseen. */
    function settle(fresh, anchor, y0, key, before) {
      var target = anchor, ty = y0;
      if (!shown(anchor)) {   /* klikattu osio tiivistyi → sen yhteenvetorivi klikatun kohdan paikalle */
        var own = root.querySelector('.lux-sum[data-k="' + key + '"]');
        if (!shown(own)) return;
        target = own; ty = Math.min(Math.max(y0, 96), window.innerHeight - 160);
      }
      /* vieritys korjataan KERRAN heti (ei rAF-silmukkaa → ei riipu pääsäikeestä) */
      var dy = target.getBoundingClientRect().top - ty;
      if (Math.abs(dy) > 0.5) window.scrollTo({ top: window.pageYOffset + dy, behavior: 'instant' });
      if (before && !calm) flip(before);
      if (!calm) fresh.forEach(function (x) { x.r.classList.remove('lux-flash'); void x.r.offsetWidth; x.r.classList.add('lux-flash'); setTimeout(function () { x.r.classList.remove('lux-flash'); }, 1300); });
    }
    /* 10.10.2026 FLIP: lopullinen asettelu tehdään heti, ja paneelin osat liukuvat vanhoilta paikoiltaan uusille
       transform-animaatioilla. Transform ajetaan näytönohjaimella → liike pysyy sulavana, vaikka ensimmäisellä
       valinnalla ladataan ja puretaan kuvia samaan aikaan (aiempi korkeusanimaatio nyki juuri siksi ensimmäisellä kerralla). */
    var panel = root.querySelector('.lastu-k__panel') || root;
    function kids() { return [].slice.call(panel.children); }
    function snap() { var m = new Map(); kids().forEach(function (el) { if (el.getClientRects().length) m.set(el, el.getBoundingClientRect().top); }); return m; }
    function flip(before) {
      var vh = window.innerHeight;
      kids().forEach(function (el) {
        if (!el.getClientRects().length || !el.animate) return;
        var now = el.getBoundingClientRect(), b = before.get(el);
        if (b == null) {   /* uusi yhteenvetorivi: lähtee osionsa vanhasta yläreunasta ja ilmestyy */
          var k = el.getAttribute('data-k'), g0 = k && groups[k] && groups[k][0];
          b = g0 ? before.get(g0) : null;
          el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
          if (b == null) return;
        }
        var d = b - now.top;
        if (Math.abs(d) < 1) return;
        if ((now.bottom < -200 && now.bottom + d < -200) || (now.top > vh + 200 && now.top + d > vh + 200)) return;   /* ei näy kummassakaan → ei animoida */
        el.animate([{ transform: 'translateY(' + d.toFixed(1) + 'px)' }, { transform: 'none' }], { duration: 340, easing: 'cubic-bezier(.2,.8,.2,1)' });
      });
    }
    /* 10.10.2026 ESILATAUS: ensimmäisen valinnan jälkeen kaiverrus-, MagSafe-, KRIP/KARB- ym. kuvat ladataan ja
       puretaan taustalla vapaalla hetkellä (4 kerrallaan) → ensimmäinen avaus on yhtä sulava kuin toinen.
       Puhelinmallien kuvia (~70 × 100+ kt) EI esiladata. saveData → ei esilatausta. */
    var warmed = false;
    function warm() {
      if (warmed) return; warmed = true;
      try { if (navigator.connection && navigator.connection.saveData) return; } catch (e) {}
      var urls = {};
      (function walk(o, depth) {
        if (o == null || depth > 7) return;
        if (typeof o === 'string') { if (/^(https?:)?\/\/[^\s]+\.(webp|png|jpe?g)(\?|$)/i.test(o)) urls[o] = 1; return; }
        if (typeof o !== 'object') return;
        Object.keys(o).forEach(function (k) { if (k !== 'brands') walk(o[k], depth + 1); });
      })(D, 0);
      root.querySelectorAll('img[loading="lazy"]').forEach(function (im) { if (!im.closest('.lastu-k__stage')) im.loading = 'eager'; });
      var list = Object.keys(urls), i = 0, idle = window.requestIdleCallback || function (f) { return setTimeout(f, 60); };
      (function next() {
        var batch = list.slice(i, i + 4); i += 4; if (!batch.length) return;
        Promise.all(batch.map(function (u) { var im = new Image(); im.decoding = 'async'; im.src = u; return im.decode ? im.decode().catch(function () {}) : Promise.resolve(); }))
          .then(function () { idle(next, { timeout: 1500 }); });
      })();
    }
    /* Valinta osiossa X → muut VALMIIT osiot tiivistyvät; X itse pysyy auki. */
    function interact(ev) {
      var t = ev.target, key = sectionOf(t); if (!key) return;
      if (t.hasAttribute && t.hasAttribute('data-engraving-index')) picked = true;
      if (t.hasAttribute && t.hasAttribute('data-persona')) picked = false;   /* uusi personointi → esivalinta ei ole oma valinta */
      /* ankkuri = pienin klikattu kokonaisuus (valinta/kortti/kenttä), ei koko osio */
      var anchor = ev.isTrusted ? (t.closest('label') || t) : null;
      /* 10.10.2026 b: mittaus HETI napautushetkellä (capture-vaihe, ennen konfiguraattorin omia muutoksia) = se mitä asiakas näki.
         Aiemmin mitattiin 30 ms myöhemmin, jolloin konfiguraattorin oma liuku (kFlush) oli jo käynnissä → kaksi animaatiota
         samoille osille ensimmäisellä avauksella → näkymä "haki paikkaansa" ja tärähti. */
      var y0 = anchor && shown(anchor) ? anchor.getBoundingClientRect().top : null;
      var before = ev.isTrusted && mob() && y0 !== null && !calm ? snap() : null;
      setTimeout(function () {
        /* konfiguraattorin omat transform-liu'ut paneelin osissa pois → yksi yhtenäinen FLIP (alla) hoitaa kaiken liikkeen */
        if (before) kids().forEach(function (el) { (el.getAnimations ? el.getAnimations() : []).forEach(function (a) { try { var kf = a.effect && a.effect.getKeyframes ? a.effect.getKeyframes() : []; if (kf.some(function (k) { return k.transform && k.transform !== 'none'; }) && !kf.some(function (k) { return k.clipPath; })) a.cancel(); } catch (e) {} }); });
        if (key === 'phone') { closed.phone = !!K.currentModel(); }
        else { closed[key] = false; Object.keys(groups).forEach(function (k) { if (k !== key && value(k) !== null) closed[k] = true; }); }
        var fresh = apply();
        if (mob() && y0 !== null) settle(fresh, anchor, y0, key, before);
        if (!warmed) (window.requestIdleCallback || function (f) { setTimeout(f, 800); })(warm, { timeout: 2500 });
      }, 30);
    }
    root.addEventListener('change', interact, true);
    root.addEventListener('input', function (ev) { if (ev.target && ev.target.matches && ev.target.matches('textarea, input[type="text"], input[type="search"]')) interact(ev); }, true);
    var errEl = document.getElementById('lastu-k-error');
    if (errEl && 'MutationObserver' in window) new MutationObserver(function () { if (!errEl.hidden) { Object.keys(closed).forEach(function (k) { closed[k] = false; }); apply(); } }).observe(errEl, { attributes: true, attributeFilter: ['hidden'] });
    addEventListener('resize', apply);
    closed.phone = !!K.currentModel();
    apply();
  }
  if (window.__lastuK && window.__lastuK.currentModel) start(); else document.addEventListener('lastu-k:ready', start);
  window.addEventListener('load', start);
})();
